import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData';

function TaskStatusAct() {
    return (
        <SettingsMetaData propertyName={"TaskStatusAct"} viewPropertyName={"TaskStatus"} />
      );
}

export default TaskStatusAct
